export { default } from "./DispensaryMenuItems";
